"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Link = void 0;
var create_entity_1 = require("../../utils/create-entity");
var entity_select_transform_1 = require("../../utils/entity-select-transform");
exports.Link = {
  name: 'Link',
  autoRoutes: ['create', 'list', 'update'],
  canCreateInConversation: true,
  select: {
    transform: function (entity, context) {
      return __assign(__assign({}, (0, entity_select_transform_1.entitySelectTransform)(entity, context)), {
        label: "".concat(entity.name, " - ").concat(entity.url),
        valueIcon: context.icons.BookmarkCircle,
        valueLabel: "".concat(entity.name),
        description: entity.url
      });
    },
    queryFields: "\n      url\n    "
  },
  table: {
    fieldNames: ["info", "isDownload", "types"]
  },
  list: {
    resultsVariant: 'table',
    hasSearch: true,
    hasFilters: true
  },
  filters: {
    fields: {
      types: {
        entityTypeName: 'LinkType'
      }
    }
  },
  form: {
    modal: {
      maxWidth: "1000px",
      fill: true
    },
    paginate: true,
    fieldSets: [{
      name: 'overview',
      intro: "Define a link to web content by specifying a URL below, OR select an item in the 'LINK TARGET' tab to link to something internally."
    }, {
      name: 'target',
      label: 'Link Target',
      intro: 'As an alternative to providing a URL, select a single item in the selects below to link to instead.'
    }, {
      name: 'banner',
      label: 'Banner',
      intro: 'Setup more specific content when this {{LINK}} is shown in a banner.'
    }],
    fields: __assign(__assign({}, create_entity_1.entityStandardFormFields), {
      url: {
        type: 'url'
      },
      label: {
        type: 'text',
        recommended: true,
        description: "What label should generally be used when showing the web link to this URL?"
      },
      isDownload: {
        type: 'boolean',
        recommended: false,
        description: "Is this {{LINK}} a downloadable file?"
      },
      types: {
        type: 'linkedMultiple',
        entityTypeName: 'LinkType',
        description: 'What type of {{LINK}} is this?'
      },
      description: {
        type: 'description',
        recommended: false
      },
      image: {
        type: 'image',
        description: 'Specify an image for a thumbnail representing this {{LINK}}'
      },
      icon: {
        type: 'linked',
        entityTypeName: 'Icon'
      },
      color: {
        type: 'linked',
        entityTypeName: 'Color'
      },
      page: {
        type: 'linked',
        fieldSet: 'target',
        entityTypeName: 'Page',
        description: "Alternatively, point this link to a {{PAGE}} instead of specifying a URL."
      },
      post: {
        type: 'linked',
        fieldSet: 'target',
        entityTypeName: 'Post',
        description: "Alternatively, which {{POST}} does this link target?"
      },
      file: {
        type: 'linked',
        fieldSet: 'target',
        entityTypeName: 'FileAsset',
        description: "Alternatively, which {{FILE_ASSET}} does this link target?"
      },
      video: {
        type: 'linked',
        fieldSet: 'target',
        entityTypeName: 'Video',
        description: "Alternatively, which {{VIDEO}} does this link target?"
      },
      event: {
        type: 'linked',
        fieldSet: 'target',
        entityTypeName: 'Event',
        description: "Alternatively, which {{EVENT}} does this link target?"
      },
      organisation: {
        type: 'linked',
        fieldSet: 'target',
        entityTypeName: 'Organisation',
        description: "Alternatively, which {{ORGANISATION}} does this link target?"
      },
      person: {
        type: 'linked',
        fieldSet: 'target',
        entityTypeName: 'Person',
        description: "Alternatively, which {{PERSON}} does this link target?"
      },
      economy: {
        type: 'linked',
        fieldSet: 'target',
        entityTypeName: 'Economy',
        description: "Alternatively, which {{ECONOMY}} does this link target?"
      },
      product: {
        type: 'linked',
        fieldSet: 'target',
        entityTypeName: 'Product',
        description: "Alternatively, which {{PRODUCT}} does this link target?"
      },
      team: {
        type: 'linked',
        fieldSet: 'target',
        entityTypeName: 'Team',
        description: "Alternatively, which {{TEAM}} does this link target?"
      },
      podcast: {
        type: 'linked',
        fieldSet: 'target',
        entityTypeName: 'Podcast',
        description: "Alternatively, which {{PODCAST}} does this link target?"
      },
      banner: {
        type: 'linked',
        fieldSet: 'overview',
        entityTypeName: 'Banner',
        description: "Provide a {{BANNER}} for this link, if required."
      },
      bannerTitle: {
        type: 'text',
        fieldSet: 'banner',
        label: 'Banner Title',
        description: 'What title should be used when showing this {{LINK}} in a banner? If not specified the title or name of any link target will be used instead.'
      },
      bannerSubtitle: {
        type: 'text',
        fieldSet: 'banner',
        label: 'Banner Subtitle',
        description: 'What subtitle should be used when showing this {{LINK}} in a banner?'
      }
    })
  }
};